var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useGlobalDispatch, useProfileState } from '../../hooks';
import { getSelectValue } from '../AsyncSelectModal';
import { fetchAffiliatons, fetchLogin } from '../../requests';
export function handleIconSSOLogins(_a) {
    var appName = _a.appName, affiliations = _a.affiliations, link = _a.link, email = _a.email, staffId = _a.staffId;
    return __awaiter(this, void 0, void 0, function () {
        var affiliationId, isBrandCentral, uniqueIds_1, filteredAffiliations_1, selected, error_1, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    isBrandCentral = appName === 'brand_central' ? true : false;
                    if (!isBrandCentral) return [3 /*break*/, 6];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 6]);
                    if (!(affiliations && (affiliations === null || affiliations === void 0 ? void 0 : affiliations.length) > 1)) return [3 /*break*/, 3];
                    uniqueIds_1 = [];
                    filteredAffiliations_1 = [];
                    affiliations.forEach(function (a) {
                        if (!uniqueIds_1.includes(a.userToShopId)) {
                            filteredAffiliations_1.push(a);
                            uniqueIds_1.push(a.userToShopId);
                        }
                    });
                    return [4 /*yield*/, getSelectValue('Select an account to use.', filteredAffiliations_1.map(function (affiliation) { return ({
                            value: affiliation,
                            id: affiliation.userToShopId,
                            label: affiliation.shop,
                        }); }))];
                case 2:
                    selected = _b.sent();
                    affiliationId = selected.userToShopId;
                    return [3 /*break*/, 4];
                case 3:
                    if ((affiliations === null || affiliations === void 0 ? void 0 : affiliations.length) === 1) {
                        affiliationId = affiliations[0].userToShopId;
                    }
                    _b.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    error_1 = _b.sent();
                    // closed the modal without selection
                    return [2 /*return*/];
                case 6:
                    _b.trys.push([6, 8, , 9]);
                    return [4 /*yield*/, fetchLogin({
                            appName: appName,
                            link: link,
                            email: email,
                            affiliationId: affiliationId,
                            staffId: staffId,
                        })];
                case 7:
                    _b.sent();
                    return [3 /*break*/, 9];
                case 8:
                    error_2 = _b.sent();
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    });
}
export function AppCard(_a) {
    var _this = this;
    var app = _a.app, category = _a.category;
    var name = app.name, link = app.link;
    var _b = useState(null), affiliations = _b[0], setAffiliations = _b[1];
    var dispatch = useGlobalDispatch();
    var profile = useProfileState();
    useEffect(function () {
        fetchAffiliatons(profile)
            .then(function (affiliations) { return setAffiliations(affiliations); })
            .catch(function (error) { return console.log(error); });
    }, [profile]);
    var email = profile.email, staffId = profile.staffId;
    var handleIconClick = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: 'set global loading', payload: true });
                    return [4 /*yield*/, handleIconSSOLogins({
                            appName: name,
                            affiliations: affiliations,
                            link: link,
                            email: email,
                            staffId: staffId,
                        })];
                case 1:
                    _a.sent();
                    dispatch({ type: 'set global loading', payload: false });
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(CardContainer, __assign({ category: category }, { children: _jsxs("div", __assign({ onClick: handleIconClick }, { children: [_jsx("div", __assign({ className: 'icon-container' }, { children: _jsx("img", { src: app.icon, alt: app.label }, void 0) }), void 0),
                _jsx("p", { children: app.label }, void 0)] }), void 0) }), void 0));
}
var CardContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 120px;\n  height: 120px;\n  cursor: pointer;\n  padding: 20px 0;\n  &:hover {\n    background: rgba(218, 220, 224, 0.25);\n  }\n\n  @media (max-width: 520px) {\n    width: 50px;\n    margin-right: ", ";\n    &:hover {\n      background: none;\n    }\n  }\n\n  .link-container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  a {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .icon-container {\n    width: 56px;\n    height: 56px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    @media (max-width: 500px) {\n      width: 44px;\n      height: 44px;\n    }\n\n    img {\n      align-self: center;\n      max-width: 100%;\n      max-height: 100%;\n    }\n  }\n\n  p {\n    font-size: 1.6rem;\n    letter-spacing: 0.01px;\n    color: #666666;\n    text-align: center;\n\n    @media (max-width: 500px) {\n      font-size: 1.4rem;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 120px;\n  height: 120px;\n  cursor: pointer;\n  padding: 20px 0;\n  &:hover {\n    background: rgba(218, 220, 224, 0.25);\n  }\n\n  @media (max-width: 520px) {\n    width: 50px;\n    margin-right: ", ";\n    &:hover {\n      background: none;\n    }\n  }\n\n  .link-container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  a {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .icon-container {\n    width: 56px;\n    height: 56px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    @media (max-width: 500px) {\n      width: 44px;\n      height: 44px;\n    }\n\n    img {\n      align-self: center;\n      max-width: 100%;\n      max-height: 100%;\n    }\n  }\n\n  p {\n    font-size: 1.6rem;\n    letter-spacing: 0.01px;\n    color: #666666;\n    text-align: center;\n\n    @media (max-width: 500px) {\n      font-size: 1.4rem;\n    }\n  }\n"])), function (_a) {
    var category = _a.category;
    return (category === 'all' ? '40px' : '0');
});
var templateObject_1;
